import { getGetCare } from './GetCare.js';
import { getInsuranceAndBilling } from './InsuranceAndBilling.js';
import { getInBox } from './InBox.js';
import { getProfileMenuItems } from './Profile.js';
import { getBSWPharmacy } from './BSWPharmacy.js';
import { getSettingMenuItems } from './SettingMenuItems.js';
const signOutItem = {
        show: true,
        label: 'Sign Out',
        url: null,
        className: 'sign-out-link'
    };
import { getSignOutMenuItem } from './SignOutMenuItem.js';

export function getSiteMenuItems(props,state) {
    const { hasMyChart, epicEHRDown, bundle, currentPharmacyUser, isProxyUser, enablePrayerFeature, enableCareCompanion, isActiveFeature_Amity, isMyChartInActive} = props;
    const pathname = typeof window !== "undefined" ? window.location.pathname.toLowerCase() : "";
    const isPharmacy = bundle === "pharmacy" || pathname.indexOf('/pharmacy') === 0;
    const isMyBSWHealth = bundle === "mybswhealth" && !isPharmacy;
    const notPharmacyProxy = isMyBSWHealth || isPharmacy && !currentPharmacyUser;
    const isMyChartProxyUser = isProxyUser;

    return [
        addSignOutToSubMenus(getGetCare(props))
        ,{
            show: notPharmacyProxy && hasMyChart,
            disabled: epicEHRDown || isMyChartInActive,
            navHead: {
                label: 'Appointments',
                url: '/appointments',
            },
            navItems: [],
        }
        , addSignOutToSubMenus(getInBox(props))
        , addSignOutToSubMenus(getInsuranceAndBilling(props))
        , addSignOutToSubMenus(getProfileMenuItems(props, state))
        , addSignOutToSubMenus(getBSWPharmacy(props))
        , {
            icon: 'icon-prayer-hands',
            show: !isMyChartProxyUser && notPharmacyProxy && enablePrayerFeature && isActiveFeature_Amity,
            disabled: false,
            navHead: {
                label: 'Community Support',
                url: '/communitysupport',
                altUrls: ['/communitysupport', '/prayerwall']
            },
            navItems: []
        }
        , addSignOutToSubMenus(getSettingMenuItems(props))
        , getSignOutMenuItem(props)
    ];
}

const addSignOutToSubMenus = (navItem) => {
    navItem.navItems.forEach(ni => {
        if (ni.subMenuItems && ni.subMenuItems.menuItems && ni.subMenuItems.menuItems.length > 0) {
            ni.subMenuItems.menuItems.push(signOutItem);
        }
    });
    return navItem;
}
/*
             label: 'Community Support',
            icon: 'icon-prayer-hands',
            show: !isMyChartProxyUser && notPharmacyProxy && enablePrayerFeature && isActiveFeature_Amity,
            url: '/prayerWall',
            disabled: false,
            navItems: []
 */